// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/100.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/200.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/300.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/600.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/700.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/800.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@fontsource/inter/900.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/utils/index.scss";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/logo/form-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset or Normalize Styles */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter";
}

html {
  font-size: 12px;
}

body {
  background-color: #f9fafb !important;
}

/* Set up custom properties (CSS variables) for consistency */
:root {
  --primary-color: #007bff;
  --secondary-color: #6c757d;
  --button-border-radius: 0.25rem;
  --input-border-radius: 0.25rem;
  --transition-speed: 0.3s ease-in-out;
  --signup-form-card-bg: #f3f6f9;
  /* Font family */
  --body-font-family: "Inter";
  --heading-font-family: "Inter";
  /* Body text font weight*/
  --font-regular: 400;
  --font-medium: 500;
  --font-semibold: 600;
  --font-bold: 700;
  --font-extrabold: 800;
  --font-black: 900;
  /* Font size for body text */
  --font-size-lg: 1.5rem;
  --font-size-med: 1.125rem;
  --font-size-sm: 1rem;
  --font-size-xs: 0.875rem;
  --font-szie-xxs: 0.75rem;
  /* Brand Color root css */
  --brand-100: #f2f2f2;
  --brand-200: #9fb5ce;
  --brand-300: #7090b6;
  --brand-400: #406b9d;
  --brand-500: #104685;
  --brand-600: #0d386a;
  --brand-700: #0a2a50;
  --brand-800: #061c35;
  --brand-900: #3a1c73;
  /* Blue color root css */
  --blue-100: #d5eefc;
  --blue-200: #acddf9;
  --blue-300: #82ccf7;
  --blue-400: #59bbf4;
  --blue-500: #2faaf1;
  --blue-600: #2688c1;
  --blue-700: #1c6691;
  --blue-800: #134460;
  --blue-900: #092230;
  /* Yellow color root css */
  --yellow-100: #fdfcd8;
  --yellow-200: #fbf8b1;
  --yellow-300: #f8f58b;
  --yellow-400: #f6f164;
  --yellow-500: #f4ee3d;
  --yellow-600: #c3be31;
  --yellow-700: #928f25;
  --yellow-800: #625f18;
  --yellow-900: #31300c;
  /* Green color root css */
  --green-100: #d6eedd;
  --green-200: #aedcba;
  --green-300: #85cb98;
  --green-400: #5db975;
  --green-500: #34a853;
  --green-600: #2a8642;
  --green-700: #1f6532;
  --green-800: #154321;
  --green-900: #0a2211;
  /* Orange color root css */
  --orange-100: #ffeecc;
  --orange-200: #ffdd99;
  --orange-300: #ffcc67;
  --orange-400: #ffbb34;
  --orange-500: #ffaa01;
  --orange-600: #cc8801;
  --orange-700: #996601;
  --orange-800: #664400;
  --orange-900: #332200;
  /* Red color root css  */
  --red-100: #f0d4d2;
  --red-200: #e1a8a5;
  --red-300: #d17d77;
  --red-400: #c2514a;
  --red-500: #b3261d;
  --red-600: #8f1e17;
  --red-700: #6b1711;
  --red-800: #480f0c;
  --red-900: #240806;
  /* Gray color root css */
  --gray-000: #ffffff;
  --gray-100: #fafafa;
  --gray-200: #f4f4f4;
  --gray-300: #f0f0f0;
  --gray-400: #e4e4e4;
  --gray-500: #e0e0e0;
  --gray-600: #9e9e9e;
  --gray-700: #757575;
  --gray-800: #212121;
  --gray-900: #000000;
  --card-greeen-500-bg: rgba(52, 168, 83, 0.08);
  --card-red-500-bg: rgba(179, 38, 29, 0.08);
  --card-orange-100-bg: rgba(255, 238, 204, 0.5);
  --card-gray-100-bg: rgba(16, 70, 133, 0.06);
  --natural-300: #dfe0e2;
  --ucc-newcontract-form-comp: #f6f8fa;
  /* start UCC related CSS root variable */
  --page-content: calc(100vh - 145px);
  --page-content-min: calc(100vh - 200px);
  --page-content-min2: calc(100vh - 215px);
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #34a853;
  --toastify-color-warning: #cc8801;
  --toastify-color-error: #b3261d;
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);
}

/* AMS Card backgrounds */
.natural-300 {
  color: var(--natural-300);
}

.bg-natural-300 {
  background-color: var(--natural-300);
}

.bg-ams-green {
  background-color: var(--card-greeen-500-bg);
}

.bg-ams-red {
  background-color: var(--card-red-500-bg);
}

.bg-ams-orange {
  background-color: var(--card-orange-100-bg);
}

.bg-ams-gray {
  background-color: var(--card-gray-100-bg);
}

.ch-box {
  min-width: 14rem;
}

.bg-fff {
  background-color: var(--card-gray-100-bg);
}

/* UCC Sprint css */
.ucc-form-card {
  background: var(--ucc-newcontract-form-comp);
}

/* Toggle button css for AMS section */
.toggleContainer {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: fit-content;
  border: 3px solid var(--gray-000);
  border-radius: 20px;
  background: var(--gray-000);
  font-weight: bold;
  color: var(--gray-000);
  cursor: pointer;
}

.toggleContainer::before {
  content: "";
  position: absolute;
  width: 50%;
  height: 100%;
  left: 0%;
  border-radius: 20px;
  background: var(--brand-500);
  transition: all 0.3s;
}

.toggleCheckbox:checked + .toggleContainer::before {
  left: 50%;
}

.toggleContainer div {
  padding: 6px;
  text-align: center;
  z-index: 1;
}

.toggleCheckbox {
  display: none;
}

.toggleCheckbox:checked + .toggleContainer div:first-child {
  color: var(--brand-500);
  transition: color 0.3s;
}

.toggleCheckbox:checked + .toggleContainer div:last-child {
  color: var(--gray-000);
  transition: color 0.3s;
}

.toggleCheckbox + .toggleContainer div:first-child {
  color: var(--gray-000);
  transition: color 0.3s;
}

.toggleCheckbox + .toggleContainer div:last-child {
  color: var(--brand-500);
  transition: color 0.3s;
}

/* Color utiles class*/
.brand-100 {
  color: var(--brand-100);
}

.brand-200 {
  color: var(--brand-200);
}

.brand-300 {
  color: var(--brand-300);
}

.brand-400 {
  color: var(--brand-400);
}

.brand-500 {
  color: var(--brand-500);
}

.brand-600 {
  color: var(--brand-600);
}

.brand-700 {
  color: var(--brand-700);
}

.brand-800 {
  color: var(--brand-800);
}

.brand-900 {
  color: var(--brand-900);
}

.bg-brand-100 {
  background: var(--brand-100);
}

.blue-100 {
  color: var(--blue-100);
}

.blue-200 {
  color: var(--blue-200);
}

.blue-300 {
  color: var(--blue-300);
}

.blue-400 {
  color: var(--blue-400);
}

.blue-500 {
  color: var(--blue-500);
}

.blue-600 {
  color: var(--blue-600);
}

.blue-700 {
  color: var(--blue-700);
}

.blue-800 {
  color: var(--blue-800);
}

.blue-900 {
  color: var(--blue-900);
}

.yellow-100 {
  color: var(--yellow-100);
}

.yellow-200 {
  color: var(--yellow-200);
}

.yellow-300 {
  color: var(--yellow-300);
}

.yellow-400 {
  color: var(--yellow-400);
}

.yellow-500 {
  color: var(--yellow-500);
}

.yellow-600 {
  color: var(--yellow-600);
}

.yellow-700 {
  color: var(--yellow-700);
}

.yellow-800 {
  color: var(--yellow-800);
}

.yellow-900 {
  color: var(--yellow-900);
}

.green-100 {
  color: var(--green-100);
}

.green-200 {
  color: var(--green-200);
}

.green-300 {
  color: var(--green-300);
}

.green-400 {
  color: var(--green-400);
}

.green-500 {
  color: var(--green-500);
}

.green-600 {
  color: var(--green-600);
}

.green-700 {
  color: var(--green-700);
}

.green-800 {
  color: var(--green-800);
}

.green-900 {
  color: var(--green-900);
}

.orange-100 {
  color: var(--orange-100);
}

.orange-200 {
  color: var(--orange-200);
}

.orange-300 {
  color: var(--orange-300);
}

.orange-400 {
  color: var(--orange-400);
}

.orange-500 {
  color: var(--orange-500);
}

.orange-600 {
  color: var(--orange-600);
}

.orange-700 {
  color: var(--orange-700);
}

.orange-800 {
  color: var(--orange-800);
}

.orange-900 {
  color: var(--orange-900);
}

.red-100 {
  color: var(--red-100);
}

.red-200 {
  color: var(--red-200);
}

.red-300 {
  color: var(--red-300);
}

.red-400 {
  color: var(--red-400);
}

.red-500 {
  color: var(--red-500);
}

.red-600 {
  color: var(--red-600);
}

.red-700 {
  color: var(--red-700);
}

.red-800 {
  color: var(--red-800);
}

.red-900 {
  color: var(--red-900);
}

.gray-000 {
  color: var(--gray-000);
}

.gray-100 {
  color: var(--gray-100);
}

.gray-200 {
  color: var(--gray-200);
}

.gray-300 {
  color: var(--gray-300);
}

.gray-400 {
  color: var(--gray-400);
}

.gray-500 {
  color: var(--gray-500);
}

.gray-600 {
  color: var(--gray-600);
}

.gray-700 {
  color: var(--gray-700);
}

.gray-800 {
  color: var(--gray-800);
}

.gray-900 {
  color: var(--gray-900);
}

/* Utility Classes */
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.head-black {
  font-weight: var(--font-black);
}

.head-bold {
  font-weight: var(--font-bold);
}

.error {
  color: var(--red-500);
}

.font-regular {
  font-weight: var(--font-regular);
}

.font-medium {
  font-weight: var(--font-medium);
}

.font-semibold {
  font-weight: var(--font-semibold);
}

.font-bold {
  font-weight: var(--font-bold);
}

.font-extrabold {
  font-weight: var(--font-extrabold);
}

.font-black {
  font-weight: var(--font-black);
}

.body-l {
  font-family: var(--body-font-family);
  font-size: 1.5rem;
  font-style: normal;
  line-height: 2rem;
  letter-spacing: -0.008rem;
}

.body-m {
  font-family: var(--body-font-family);
  font-size: 1.125rem;
  font-style: normal;
  line-height: 1.5rem;
  letter-spacing: -0.008rem;
}

.body-s {
  font-family: var(--body-font-family);
  font-size: 1rem;
  font-style: normal;
  line-height: 1.5rem;
  letter-spacing: -0.005rem;
}

.body-xs {
  font-family: var(--body-font-family);
  font-size: 0.875rem;
  font-style: normal;
  line-height: 1.25rem;
  letter-spacing: -0.004rem;
}

.body-xxs {
  font-family: var(--body-font-family);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-style: normal;
  letter-spacing: -0.004rem;
}

/* Typography */
.head-xl {
  font-size: 5.5rem;
  font-style: normal;
  line-height: 5.75rem;
  letter-spacing: -0.055rem;
}

.head-l {
  font-size: 4rem;
  font-style: normal;
  line-height: 4.25rem;
  letter-spacing: -0.04rem;
}

.head-m {
  font-size: 2.5rem;
  font-style: normal;
  line-height: 2.75rem;
  letter-spacing: -0.025rem;
}

.head-s {
  font-size: 2rem;
  font-style: normal;
  line-height: 2.25rem;
  letter-spacing: -0.02rem;
}

.head-xs {
  font-size: 1.5rem;
  font-style: normal;
  line-height: 2.25rem;
  letter-spacing: -0.015rem;
}

.head-xxs {
  font-size: 1rem;
  font-style: normal;
  line-height: 1.5rem;
  letter-spacing: -0.01rem;
}

/* ===================================
  Start Form related css
===================================  */
.form-page-container {
  background: #ecf0f5;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: bottom;
  margin: 0 auto;
  background-size: 100%;
  overflow: auto;
  padding-top: 2.5rem;
}

.form-page {
  width: 94rem;
  height: 64rem;
  max-height: 100vh;
  max-width: 100%;
  padding: 0 24px;
  margin: 0 auto;
  justify-content: flex-end;
  display: flex;
}

.form-container {
  width: 28.125rem;
  background: #fff;
  border-radius: 1.5rem;
  box-shadow: 0px 0.125rem 0.25rem 0px rgba(0, 0, 0, 0.16);
  float: right;
}

.left-section,
.right-section {
  flex: 1 1;
}

.left-section > .formTitle {
  color: var(--grey-800, #212121);
  font-size: 3.5rem;
  font-style: normal;
  font-weight: 300;
  line-height: 4.5rem;
  letter-spacing: -0.035rem;
  margin-top: 5rem;
}

.separator-text {
  color: var(--gray--800);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: var(--font-medium);
  line-height: 1.25rem;
  letter-spacing: -0.004rem;
}

.link {
  color: var(--gray-700);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: var(-font-regular);
  line-height: 1.25rem;
  letter-spacing: -0.004rem;
}

.getHelpContainer {
  font-size: 0.75rem;
}

.getHelp {
  color: var(--brand-500);
}

.cardList {
  padding: 20px 20px;
  list-style: none;
}

.cardList .listItem:not(:last-child) {
  margin-bottom: 14px;
}

.details-text {
  background: var(--signup-form-card-bg);
  border-radius: 0.5rem;
}

.center-vrt-rgt {
  align-items: center;
  display: flex;
  justify-content: end;
}

.success-card {
  background-color: #ebf6ee;
  padding: 20px;
  border-radius: 0.5rem;
}

@media screen and (max-width: 767px) {
  .form-page {
    display: block;
    max-width: 90%;
    width: 90%;
    margin: 0 auto;
    padding: 0;
    margin-bottom: 60px;
  }
  .form-container {
    max-width: 100%;
    min-width: 100%;
    display: block;
    float: none;
  }
}
/* End here form related css*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--heading-font-family);
  font-weight: 600;
}

p {
  font-size: var(--font-size-base);
}

a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color var(--transition-speed);
}

a:hover {
  color: var(--secondary-color);
}

/* Media Queries */
@media (max-width: 768px) {
  .container {
    padding: 0 2rem;
  }
  .row {
    flex-direction: column;
  }
}
.stepper-hd {
  display: inline-flex;
  gap: 0.5rem;
  color: #1c1d1f;
  font-weight: bold;
  word-wrap: break-word;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #cfdae7;
}

.stepper-input {
  font-size: 14px;
  font-weight: 400;
  border-color: #cfcfcf;
  word-wrap: break-word;
}

.ol-zoom {
  bottom: 8.5em !important;
  right: 1.5em;
  left: unset;
  top: auto;
}

.app-payment-due {
  color: #b3261d;
}

.license-info-bar {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1215686275);
}

.pdf-document {
  width: 100%;
  height: auto !important;
  min-height: 0 !important;
  overflow: visible !important;
}

.pdf-document img {
  max-width: 100%;
  height: auto;
}

.pdf-document p,
.pdf-document li,
.pdf-document div {
  overflow-wrap: break-word;
}

@media print {
  @page {
    size: A4;
    margin: 8mm 10mm;
  }
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
    overflow: visible !important;
  }
  .pdf-document {
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
    color: #000 !important;
    print-color-adjust: exact;
  }
  .pdf-document * {
    color: #000 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA,8BAAA;AACA;;;EAGE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,oBAAA;AAYF;;AATA;EAEE,eAAA;AAWF;;AARA;EACE,oCAAA;AAWF;;AAKA,6DAAA;AACA;EACE,wBAAA;EACA,0BAAA;EAEA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,8BAAA;EAEA,gBAAA;EACA,2BAAA;EACA,8BAAA;EAEA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EAEA,4BAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,yBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,0BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,yBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,0BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,6CAAA;EACA,0CAAA;EACA,8CAAA;EACA,2CAAA;EACA,sBAAA;EACA,oCAAA;EAEA,wCAAA;EACA,mCAAA;EACA,uCAAA;EACA,wCAAA;EAEA,4BAAA;EACA,8BAAA;EACA,8BAAA;EACA,iCAAA;EACA,iCAAA;EACA,+BAAA;EAEA,sDAAA;EACA,4DAAA;EACA,4DAAA;EACA,wDAAA;AAjBF;;AAoBA,yBAAA;AAEA;EACE,yBAAA;AAlBF;;AAoBA;EACE,oCAAA;AAjBF;;AAmBA;EACE,2CAAA;AAhBF;;AAmBA;EACE,wCAAA;AAhBF;;AAmBA;EACE,2CAAA;AAhBF;;AAmBA;EACE,yCAAA;AAhBF;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,yCAAA;AAfF;;AAkBA,mBAAA;AACA;EACE,4CAAA;AAfF;;AAkBA,sCAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AAfF;;AAiBA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,4BAAA;EACA,oBAAA;AAdF;;AAgBA;EACE,SAAA;AAbF;;AAeA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AAZF;;AAcA;EACE,aAAA;AAXF;;AAaA;EACE,uBAAA;EACA,sBAAA;AAVF;;AAYA;EACE,sBAAA;EACA,sBAAA;AATF;;AAWA;EACE,sBAAA;EACA,sBAAA;AARF;;AAUA;EACE,uBAAA;EACA,sBAAA;AAPF;;AAUA,sBAAA;AACA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,4BAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA,oBAAA;AACA;EACE,kBAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA;EACE,6BAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,gCAAA;AAPF;;AAUA;EACE,+BAAA;AAPF;;AAUA;EACE,iCAAA;AAPF;;AAUA;EACE,6BAAA;AAPF;;AAUA;EACE,kCAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA;EACE,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,oCAAA;EACA,mBAAA;EAEA,kBAAA;EACA,oBAAA;EACA,yBAAA;AARF;;AAWA;EACE,oCAAA;EACA,kBAAA;EAEA,qBAAA;EACA,kBAAA;EACA,yBAAA;AATF;;AAYA,eAAA;AACA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AATF;;AAYA;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;AATF;;AAYA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AATF;;AAYA;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;AATF;;AAYA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AATF;;AAYA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AATF;;AAYA;;sCAAA;AAGA;EACE,mBAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,qBAAA;EAEA,cAAA;EACA,mBAAA;AAVF;;AAYA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;AATF;;AAYA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wDAAA;EACA,YAAA;AATF;;AAYA;;EAEE,SAAA;AATF;;AAWA;EACE,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AARF;;AAUA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AASA;EACE,kBAAA;EACA,gBAAA;AANF;;AAQA;EACE,mBAAA;AALF;;AAWA;EACE,sCAAA;EACA,qBAAA;AARF;;AAUA;EACE,mBAAA;EACA,aAAA;EACA,oBAAA;AAPF;;AASA;EACE,yBAAA;EACA,aAAA;EAEA,qBAAA;AAPF;;AASA;EACE;IACE,cAAA;IACA,cAAA;IACA,UAAA;IACA,cAAA;IACA,UAAA;IACA,mBAAA;EANF;EAQA;IACE,eAAA;IACA,eAAA;IACA,cAAA;IACA,WAAA;EANF;AACF;AASA,6BAAA;AAEA;;;;;;EAME,uCAAA;EACA,gBAAA;AARF;;AAYA;EAEE,gCAAA;AAVF;;AAaA;EACE,2BAAA;EACA,qBAAA;EACA,yCAAA;AAVF;;AAaA;EACE,6BAAA;AAVF;;AAaA,kBAAA;AACA;EACE;IACE,eAAA;EAVF;EAaA;IACE,sBAAA;EAXF;AACF;AAcA;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EAEA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gCAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAbF;;AA+BA;EACE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,cAAA;AA5BF;;AA+BA;EACE,uDAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,YAAA;AA5BF;;AA+BA;;;EAGE,yBAAA;AA5BF;;AA+BA;EACE;IACE,QAAA;IACA,gBAAA;EA5BF;EA+BA;;IAEE,oBAAA;IACA,qBAAA;IACA,uBAAA;IACA,4BAAA;EA7BF;EAgCA;IACE,sBAAA;IACA,uBAAA;IACA,wBAAA;IACA,4BAAA;IACA,sBAAA;IAEA,yBAAA;EA9BF;EAiCA;IACE,sBAAA;EA/BF;AACF","sourcesContent":["/* Reset or Normalize Styles */\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Inter\";\n}\n\nhtml {\n  //  font-size: 0.844vw; /* Base font size */\n  font-size: 12px;\n}\n\nbody {\n  background-color: #f9fafb !important;\n}\n\n// @import url(\"./assets/styles/utils/custom.scss\");\n@import url(\"@fontsource/inter\");\n@import url(\"@fontsource/inter/100.css\");\n@import url(\"@fontsource/inter/200.css\");\n@import url(\"@fontsource/inter/300.css\");\n@import url(\"@fontsource/inter/400.css\");\n@import url(\"@fontsource/inter/500.css\");\n@import url(\"@fontsource/inter/600.css\");\n@import url(\"@fontsource/inter/700.css\");\n@import url(\"@fontsource/inter/800.css\");\n@import url(\"@fontsource/inter/900.css\");\n@import url(\"./assets/styles/utils/index.scss\");\n\n/* Set up custom properties (CSS variables) for consistency */\n:root {\n  --primary-color: #007bff;\n  --secondary-color: #6c757d;\n\n  --button-border-radius: 0.25rem;\n  --input-border-radius: 0.25rem;\n  --transition-speed: 0.3s ease-in-out;\n  --signup-form-card-bg: #f3f6f9;\n\n  /* Font family */\n  --body-font-family: \"Inter\";\n  --heading-font-family: \"Inter\";\n\n  /* Body text font weight*/\n  --font-regular: 400;\n  --font-medium: 500;\n  --font-semibold: 600;\n  --font-bold: 700;\n  --font-extrabold: 800;\n  --font-black: 900;\n\n  /* Font size for body text */\n  --font-size-lg: 1.5rem;\n  --font-size-med: 1.125rem;\n  --font-size-sm: 1rem;\n  --font-size-xs: 0.875rem;\n  --font-szie-xxs: 0.75rem;\n\n  /* Brand Color root css */\n  --brand-100: #f2f2f2;\n  --brand-200: #9fb5ce;\n  --brand-300: #7090b6;\n  --brand-400: #406b9d;\n  --brand-500: #104685;\n  --brand-600: #0d386a;\n  --brand-700: #0a2a50;\n  --brand-800: #061c35;\n  --brand-900: #3a1c73;\n\n  /* Blue color root css */\n  --blue-100: #d5eefc;\n  --blue-200: #acddf9;\n  --blue-300: #82ccf7;\n  --blue-400: #59bbf4;\n  --blue-500: #2faaf1;\n  --blue-600: #2688c1;\n  --blue-700: #1c6691;\n  --blue-800: #134460;\n  --blue-900: #092230;\n\n  /* Yellow color root css */\n  --yellow-100: #fdfcd8;\n  --yellow-200: #fbf8b1;\n  --yellow-300: #f8f58b;\n  --yellow-400: #f6f164;\n  --yellow-500: #f4ee3d;\n  --yellow-600: #c3be31;\n  --yellow-700: #928f25;\n  --yellow-800: #625f18;\n  --yellow-900: #31300c;\n\n  /* Green color root css */\n  --green-100: #d6eedd;\n  --green-200: #aedcba;\n  --green-300: #85cb98;\n  --green-400: #5db975;\n  --green-500: #34a853;\n  --green-600: #2a8642;\n  --green-700: #1f6532;\n  --green-800: #154321;\n  --green-900: #0a2211;\n\n  /* Orange color root css */\n  --orange-100: #ffeecc;\n  --orange-200: #ffdd99;\n  --orange-300: #ffcc67;\n  --orange-400: #ffbb34;\n  --orange-500: #ffaa01;\n  --orange-600: #cc8801;\n  --orange-700: #996601;\n  --orange-800: #664400;\n  --orange-900: #332200;\n\n  /* Red color root css  */\n  --red-100: #f0d4d2;\n  --red-200: #e1a8a5;\n  --red-300: #d17d77;\n  --red-400: #c2514a;\n  --red-500: #b3261d;\n  --red-600: #8f1e17;\n  --red-700: #6b1711;\n  --red-800: #480f0c;\n  --red-900: #240806;\n\n  /* Gray color root css */\n  --gray-000: #ffffff;\n  --gray-100: #fafafa;\n  --gray-200: #f4f4f4;\n  --gray-300: #f0f0f0;\n  --gray-400: #e4e4e4;\n  --gray-500: #e0e0e0;\n  --gray-600: #9e9e9e;\n  --gray-700: #757575;\n  --gray-800: #212121;\n  --gray-900: #000000;\n\n  --card-greeen-500-bg: rgba(52, 168, 83, 0.08);\n  --card-red-500-bg: rgba(179, 38, 29, 0.08);\n  --card-orange-100-bg: rgba(255, 238, 204, 0.5);\n  --card-gray-100-bg: rgba(16, 70, 133, 0.06);\n  --natural-300: #dfe0e2;\n  --ucc-newcontract-form-comp: #f6f8fa;\n\n  /* start UCC related CSS root variable */\n  --page-content: calc(100vh - 145px);\n  --page-content-min: calc(100vh - 200px);\n  --page-content-min2: calc(100vh - 215px);\n\n  --toastify-color-light: #fff;\n  --toastify-color-dark: #121212;\n  --toastify-color-info: #3498db;\n  --toastify-color-success: #34a853;\n  --toastify-color-warning: #cc8801;\n  --toastify-color-error: #b3261d;\n\n  --toastify-icon-color-info: var(--toastify-color-info);\n  --toastify-icon-color-success: var(--toastify-color-success);\n  --toastify-icon-color-warning: var(--toastify-color-warning);\n  --toastify-icon-color-error: var(--toastify-color-error);\n}\n\n/* AMS Card backgrounds */\n\n.natural-300 {\n  color: var(--natural-300);\n}\n.bg-natural-300 {\n  background-color: var(--natural-300);\n}\n.bg-ams-green {\n  background-color: var(--card-greeen-500-bg);\n}\n\n.bg-ams-red {\n  background-color: var(--card-red-500-bg);\n}\n\n.bg-ams-orange {\n  background-color: var(--card-orange-100-bg);\n}\n\n.bg-ams-gray {\n  background-color: var(--card-gray-100-bg);\n}\n.ch-box {\n  min-width: 14rem;\n}\n\n.bg-fff {\n  background-color: var(--card-gray-100-bg);\n}\n\n/* UCC Sprint css */\n.ucc-form-card {\n  background: var(--ucc-newcontract-form-comp);\n}\n\n/* Toggle button css for AMS section */\n.toggleContainer {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  width: fit-content;\n  border: 3px solid var(--gray-000);\n  border-radius: 20px;\n  background: var(--gray-000);\n  font-weight: bold;\n  color: var(--gray-000);\n  cursor: pointer;\n}\n.toggleContainer::before {\n  content: \"\";\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  left: 0%;\n  border-radius: 20px;\n  background: var(--brand-500);\n  transition: all 0.3s;\n}\n.toggleCheckbox:checked + .toggleContainer::before {\n  left: 50%;\n}\n.toggleContainer div {\n  padding: 6px;\n  text-align: center;\n  z-index: 1;\n}\n.toggleCheckbox {\n  display: none;\n}\n.toggleCheckbox:checked + .toggleContainer div:first-child {\n  color: var(--brand-500);\n  transition: color 0.3s;\n}\n.toggleCheckbox:checked + .toggleContainer div:last-child {\n  color: var(--gray-000);\n  transition: color 0.3s;\n}\n.toggleCheckbox + .toggleContainer div:first-child {\n  color: var(--gray-000);\n  transition: color 0.3s;\n}\n.toggleCheckbox + .toggleContainer div:last-child {\n  color: var(--brand-500);\n  transition: color 0.3s;\n}\n\n/* Color utiles class*/\n.brand-100 {\n  color: var(--brand-100);\n}\n\n.brand-200 {\n  color: var(--brand-200);\n}\n\n.brand-300 {\n  color: var(--brand-300);\n}\n\n.brand-400 {\n  color: var(--brand-400);\n}\n\n.brand-500 {\n  color: var(--brand-500);\n}\n\n.brand-600 {\n  color: var(--brand-600);\n}\n\n.brand-700 {\n  color: var(--brand-700);\n}\n\n.brand-800 {\n  color: var(--brand-800);\n}\n\n.brand-900 {\n  color: var(--brand-900);\n}\n\n.bg-brand-100 {\n  background: var(--brand-100);\n}\n\n.blue-100 {\n  color: var(--blue-100);\n}\n\n.blue-200 {\n  color: var(--blue-200);\n}\n\n.blue-300 {\n  color: var(--blue-300);\n}\n\n.blue-400 {\n  color: var(--blue-400);\n}\n\n.blue-500 {\n  color: var(--blue-500);\n}\n\n.blue-600 {\n  color: var(--blue-600);\n}\n\n.blue-700 {\n  color: var(--blue-700);\n}\n\n.blue-800 {\n  color: var(--blue-800);\n}\n\n.blue-900 {\n  color: var(--blue-900);\n}\n\n.yellow-100 {\n  color: var(--yellow-100);\n}\n\n.yellow-200 {\n  color: var(--yellow-200);\n}\n\n.yellow-300 {\n  color: var(--yellow-300);\n}\n\n.yellow-400 {\n  color: var(--yellow-400);\n}\n\n.yellow-500 {\n  color: var(--yellow-500);\n}\n\n.yellow-600 {\n  color: var(--yellow-600);\n}\n\n.yellow-700 {\n  color: var(--yellow-700);\n}\n\n.yellow-800 {\n  color: var(--yellow-800);\n}\n\n.yellow-900 {\n  color: var(--yellow-900);\n}\n\n.green-100 {\n  color: var(--green-100);\n}\n\n.green-200 {\n  color: var(--green-200);\n}\n\n.green-300 {\n  color: var(--green-300);\n}\n\n.green-400 {\n  color: var(--green-400);\n}\n\n.green-500 {\n  color: var(--green-500);\n}\n\n.green-600 {\n  color: var(--green-600);\n}\n\n.green-700 {\n  color: var(--green-700);\n}\n\n.green-800 {\n  color: var(--green-800);\n}\n\n.green-900 {\n  color: var(--green-900);\n}\n\n.orange-100 {\n  color: var(--orange-100);\n}\n\n.orange-200 {\n  color: var(--orange-200);\n}\n\n.orange-300 {\n  color: var(--orange-300);\n}\n\n.orange-400 {\n  color: var(--orange-400);\n}\n\n.orange-500 {\n  color: var(--orange-500);\n}\n\n.orange-600 {\n  color: var(--orange-600);\n}\n\n.orange-700 {\n  color: var(--orange-700);\n}\n\n.orange-800 {\n  color: var(--orange-800);\n}\n\n.orange-900 {\n  color: var(--orange-900);\n}\n\n.red-100 {\n  color: var(--red-100);\n}\n\n.red-200 {\n  color: var(--red-200);\n}\n\n.red-300 {\n  color: var(--red-300);\n}\n\n.red-400 {\n  color: var(--red-400);\n}\n\n.red-500 {\n  color: var(--red-500);\n}\n\n.red-600 {\n  color: var(--red-600);\n}\n\n.red-700 {\n  color: var(--red-700);\n}\n\n.red-800 {\n  color: var(--red-800);\n}\n\n.red-900 {\n  color: var(--red-900);\n}\n\n.gray-000 {\n  color: var(--gray-000);\n}\n\n.gray-100 {\n  color: var(--gray-100);\n}\n\n.gray-200 {\n  color: var(--gray-200);\n}\n\n.gray-300 {\n  color: var(--gray-300);\n}\n\n.gray-400 {\n  color: var(--gray-400);\n}\n\n.gray-500 {\n  color: var(--gray-500);\n}\n\n.gray-600 {\n  color: var(--gray-600);\n}\n\n.gray-700 {\n  color: var(--gray-700);\n}\n\n.gray-800 {\n  color: var(--gray-800);\n}\n\n.gray-900 {\n  color: var(--gray-900);\n}\n\n/* Utility Classes */\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.head-black {\n  font-weight: var(--font-black);\n}\n\n.head-bold {\n  font-weight: var(--font-bold);\n}\n\n.error {\n  color: var(--red-500);\n}\n\n.font-regular {\n  font-weight: var(--font-regular);\n}\n\n.font-medium {\n  font-weight: var(--font-medium);\n}\n\n.font-semibold {\n  font-weight: var(--font-semibold);\n}\n\n.font-bold {\n  font-weight: var(--font-bold);\n}\n\n.font-extrabold {\n  font-weight: var(--font-extrabold);\n}\n\n.font-black {\n  font-weight: var(--font-black);\n}\n\n.body-l {\n  font-family: var(--body-font-family);\n  font-size: 1.5rem;\n  font-style: normal;\n  line-height: 2rem;\n  letter-spacing: -0.008rem;\n}\n\n.body-m {\n  font-family: var(--body-font-family);\n  font-size: 1.125rem;\n  font-style: normal;\n  line-height: 1.5rem;\n  letter-spacing: -0.008rem;\n}\n\n.body-s {\n  font-family: var(--body-font-family);\n  font-size: 1rem;\n  font-style: normal;\n  line-height: 1.5rem;\n  letter-spacing: -0.005rem;\n}\n\n.body-xs {\n  font-family: var(--body-font-family);\n  font-size: 0.875rem;\n  // font-size: 14px;\n  font-style: normal;\n  line-height: 1.25rem;\n  letter-spacing: -0.004rem;\n}\n\n.body-xxs {\n  font-family: var(--body-font-family);\n  font-size: 0.75rem;\n  // font-size: 12px;\n  line-height: 1.125rem;\n  font-style: normal;\n  letter-spacing: -0.004rem;\n}\n\n/* Typography */\n.head-xl {\n  font-size: 5.5rem;\n  font-style: normal;\n  line-height: 5.75rem;\n  letter-spacing: -0.055rem;\n}\n\n.head-l {\n  font-size: 4rem;\n  font-style: normal;\n  line-height: 4.25rem;\n  letter-spacing: -0.04rem;\n}\n\n.head-m {\n  font-size: 2.5rem;\n  font-style: normal;\n  line-height: 2.75rem;\n  letter-spacing: -0.025rem;\n}\n\n.head-s {\n  font-size: 2rem;\n  font-style: normal;\n  line-height: 2.25rem;\n  letter-spacing: -0.02rem;\n}\n\n.head-xs {\n  font-size: 1.5rem;\n  font-style: normal;\n  line-height: 2.25rem;\n  letter-spacing: -0.015rem;\n}\n\n.head-xxs {\n  font-size: 1rem;\n  font-style: normal;\n  line-height: 1.5rem;\n  letter-spacing: -0.01rem;\n}\n\n/* ===================================\n  Start Form related css\n===================================  */\n.form-page-container {\n  background: #ecf0f5;\n  width: 100%;\n  background-image: url(./assets/images/logo/form-bg.png);\n  background-repeat: no-repeat;\n  background-position: bottom;\n  margin: 0 auto;\n  background-size: 100%;\n  //  height: 100vh;\n  overflow: auto;\n  padding-top: 2.5rem;\n}\n.form-page {\n  width: 94rem;\n  height: 64rem;\n  max-height: 100vh;\n  max-width: 100%;\n  padding: 0 24px;\n  margin: 0 auto;\n  justify-content: flex-end;\n  display: flex;\n}\n\n.form-container {\n  width: 28.125rem;\n  background: #fff;\n  border-radius: 1.5rem;\n  box-shadow: 0px 0.125rem 0.25rem 0px rgba(0, 0, 0, 0.16);\n  float: right;\n}\n\n.left-section,\n.right-section {\n  flex: 1;\n}\n.left-section > .formTitle {\n  color: var(--grey-800, #212121);\n  font-size: 3.5rem;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 4.5rem;\n  letter-spacing: -0.035rem;\n  margin-top: 5rem;\n}\n.separator-text {\n  color: var(--gray--800);\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: var(--font-medium);\n  line-height: 1.25rem;\n  letter-spacing: -0.004rem;\n}\n\n.link {\n  color: var(--gray-700);\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: var(-font-regular);\n  line-height: 1.25rem;\n  letter-spacing: -0.004rem;\n}\n\n.getHelpContainer {\n  font-size: 0.75rem;\n}\n\n.getHelp {\n  color: var(--brand-500);\n}\n.cardList {\n  padding: 20px 20px;\n  list-style: none;\n}\n.cardList .listItem:not(:last-child) {\n  margin-bottom: 14px;\n}\n// span.gray-700.col {\n//   max-width: 90px;\n// }\n\n.details-text {\n  background: var(--signup-form-card-bg);\n  border-radius: 0.5rem;\n}\n.center-vrt-rgt {\n  align-items: center;\n  display: flex;\n  justify-content: end;\n}\n.success-card {\n  background-color: #ebf6ee;\n  padding: 20px;\n  // border: 1px solid var(--green-900);\n  border-radius: 0.5rem;\n}\n@media screen and (max-width: 767px) {\n  .form-page {\n    display: block;\n    max-width: 90%;\n    width: 90%;\n    margin: 0 auto;\n    padding: 0;\n    margin-bottom: 60px;\n  }\n  .form-container {\n    max-width: 100%;\n    min-width: 100%;\n    display: block;\n    float: none;\n  }\n}\n\n/* End here form related css*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--heading-font-family);\n  font-weight: 600;\n  // margin-bottom: 1rem;\n}\n\np {\n  // margin-bottom: 1rem;\n  font-size: var(--font-size-base);\n}\n\na {\n  color: var(--primary-color);\n  text-decoration: none;\n  transition: color var(--transition-speed);\n}\n\na:hover {\n  color: var(--secondary-color);\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n  .container {\n    padding: 0 2rem;\n  }\n\n  .row {\n    flex-direction: column;\n  }\n}\n\n.stepper-hd {\n  display: inline-flex;\n  gap: 0.5rem;\n  color: #1c1d1f;\n  // font-size: 1.2rem !important;\n  font-weight: bold;\n  word-wrap: break-word;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #cfdae7;\n}\n\n.stepper-input {\n  font-size: 14px;\n  font-weight: 400;\n  border-color: #cfcfcf;\n  word-wrap: break-word;\n}\n\n// .text-with-line {\n//   position: relative;\n//   display: inline-block;\n// }\n\n// .text-with-line::after {\n//   content: \"\";\n//   position: absolute;\n//   right: -5rem;\n//   top: 0.5rem;\n//   width: 3rem;\n//   height: 0.1rem;\n//   background-color: #cfdae7;\n// }\n\n.ol-zoom {\n  bottom: 8.5em !important;\n  right: 1.5em;\n  left: unset;\n  top: auto;\n}\n\n.app-payment-due {\n  color: #b3261d;\n}\n\n.license-info-bar {\n  box-shadow: 0px 2px 4px 0px #0000001f;\n}\n\n.pdf-document {\n  width: 100%;\n  height: auto !important;\n  min-height: 0 !important;\n  overflow: visible !important;\n}\n\n.pdf-document img {\n  max-width: 100%;\n  height: auto;\n}\n\n.pdf-document p,\n.pdf-document li,\n.pdf-document div {\n  overflow-wrap: break-word;\n}\n\n@media print {\n  @page {\n    size: A4;\n    margin: 8mm 10mm;\n  }\n\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    height: auto !important;\n    overflow: visible !important;\n  }\n\n  .pdf-document {\n    width: 100% !important;\n    height: auto !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n    color: #000 !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .pdf-document * {\n    color: #000 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
